export class MultipartFile {
  file: File;
  fileNameWithPath: string;

  constructor(file: File, path: string) {
    this.file = file,
    this.fileNameWithPath = `${path}/${file.name}`;
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/components/controls/multipart-files/multipart-file.ts